import { forWeb } from '@ff-os/shared-utils/asset-urls';
import { LoadedShape } from 'ff-canvas';

export const loadShape = async (url: string, language: string) => {

    const assetUrl = forWeb(url, {
        w: 1000, h: 1000, language,
        accept: 'application/vnd+idt.shape+json'
    });

    const response = await fetch(assetUrl, { mode: 'cors' });

    if (response.ok) {
        return await response.json() as LoadedShape;
    } else {
        throw new Error(`Shape load error: ${url} [${response.status}]`);
    }
};